import React, { Component } from 'react';
import Highcharts from 'highcharts/highstock'
import HighchartsReact from 'highcharts-react-official'
import { withRouter } from 'react-router-dom';

import { api_host,api_auth } from '../../../../../common/globals/constants';
import at_codes_ok from '../../../../../data/codes_ok'
import PortletContent from 'components/PortletContent';
import CircularProgress from '@material-ui/core/CircularProgress';
import PerfectScrollbar from 'react-perfect-scrollbar';
import Typography from '@material-ui/core/Typography';
import moment from 'moment'
import 'moment/locale/es'  
import compose from 'recompose/compose';
import { useTranslation, withTranslation } from 'react-i18next';
moment.locale('es')

class AvailabilityNodeDetail extends Component {

    constructor(props) {
        super(props);
        this.state = {
            
            currentObjectiveId: this.props.match.params.objetivo_id,
            prevObjectiveId: this.props.match.params.objetivo_id,
            loadObjectiveData: false,
            externalData: null,
            dataError: false,
            isLoading: true,
            sla: null,
            time: 'h',
            hoverData: null,
            lastEvent: [],
            statePeriod: this.props.params.statePeriod,
            isStatePeriod: false,
            chartOptionsBase: this._chartOptionsBase(),
            chartOptions: this._chartOptionsBase(),
            isRefresh: this.props.params.isRefresh,
            date: this.props.params.date,
            dateMoment:((moment().locale('es')).format("dddd, DD/MM/YYYY, h:mm:ss a"))
        }

    }
    _chartOptionsBase = () => {
        const { t } = this.props;
        return {
        chart: {
            type: 'column'
        },
        title: {
            text: '',
            style: {
                fontSize: '' 
             }
        },
        subtitle: {
            text: '',
            style: {
                color: '',
                fontWeight: ''
            }
        },
        xAxis: {
            categories: [""],
            labels: {
                rotation: -45,
            },
            title: {
                text: t('availability-node-detail.chart.xAxis.title')
            }
        },
        yAxis: {
            min: 0,
            max: 100,
            title: {
                text: null,
            }
        },
        legend: {
            enabled: false
        },
        tooltip: {
            enabled: false,
            pointFormat: `${t('availability-node-detail.chart.tooltip.response-time')}: <b>{point.y:.2f} (s)</b>`
        },
        credits: {
            enabled: false
        },
        series: [],
        plotOptions: {
            series: {
                dataLabels: {
                    enabled: true,
                    style: {
                        textOutline: 'none'
                    }
                }
            }
        },
    }
    }

    setHoverData = (e) => {
        const { x, y, series, category } = e.target
        // The chart is not updated because `chartOptions` has not changed.
        let point = []
        point['x'] = series.userOptions.name
        point['y'] = y
        let step = category
        this.props.params.onInfo(point, step)
    }

    static getDerivedStateFromProps(props, state) {
        if (props.match.params.objetivo_id !== state.prevObjectiveId) {
            return {
                chartOptions: state.chartOptionsBase,
                externalData: null,
                prevObjectiveId: props.match.params.objetivo_id,
                time: props.params.period,
                dataError: false,
                isLoading: true,
                hoverData: null,
                lastEvent: [],
                statePeriod: props.params.statePeriod,
            }
        } else if (props.params.period !== state.time) {
            return {
                chartOptions: state.chartOptionsBase,
                externalData: null,
                prevObjectiveId: props.match.params.objetivo_id,
                time: props.params.period,
                dataError: false,
                isLoading: true,
                hoverData: null,
                lastEvent: [],
                statePeriod: props.params.statePeriod,
                isStatePeriod: props.params.isStatePeriod
            }
        }  else if ((props.params.period === state.time) && (props.params.statePeriod !== state.statePeriod)) {
            return {
                chartOptions: state.chartOptionsBase,
                prevObjectiveId: props.match.params.objetivo_id,
                time: props.params.period,
                dataError: false,
                hoverData: null,
                isLoading: true,
                lastEvent: [],
                statePeriod: props.params.statePeriod,
                isStatePeriod: props.params.isStatePeriod
            }
        } else if(props.params.isRefresh !== state.isRefresh){
            return {
                chartOptions: state.chartOptionsBase,
                externalData: null,
                prevObjectiveId: props.match.params.objetivo_id,
                time: props.params.period,
                dataError: false,
                isLoading: true,
                hoverData: null,
                lastEvent: [],
                statePeriod: props.params.statePeriod,
                isRefresh: props.params.isRefresh,          
            }

        }else if(props.params.date !== state.date){
            return {
                chartOptions: state.chartOptionsBase,
                externalData: null,
                prevObjectiveId: props.match.params.objetivo_id,
                time: props.params.period,
                dataError: false,
                isLoading: true,
                hoverData: null,
                lastEvent: [],
                statePeriod: props.params.statePeriod,
                date: props.params.date,          
            }

        }
        return null;
    }

    componentDidMount() {
        this.getDataFromAPI();
    }

    componentDidUpdate(prevProps, prevState) {
        if((prevProps.params.isRefresh !== this.state.isRefresh) && this.state.dateMoment!==((moment().locale('es')).format("dddd, MMMM YYYY, h:mm:ss a"))){
            this.props.params.onDateMoment(((moment().locale('es')).format("dddd, MMMM YYYY, h:mm:ss a")))
        }
        if ((prevProps.params.period !== this.state.time) ||
            (prevProps.match.params.objetivo_id !== this.props.match.params.objetivo_id) ||
            (prevProps.params.statePeriod !== this.state.statePeriod) ||
            (prevProps.params.isRefresh !== this.state.isRefresh)||
            (prevProps.params.date !== this.state.date)) {
            this.getDataFromAPI();
        }

    }
    componentWillUnmount() {

    }

    getDataFromAPI = (objectiveId) => {
        const { objetivo_id } = this.props.match.params
        const { fromObjective } = this.props.location.state
        const { period, statePeriod } = this.props.params
        const { history } = this.props;
        // puede necesitar agregar el schedule, guiarse por AvailabilityConsolidated
        let sla_rendimiento_ok = parseInt(fromObjective.sla_rendimiento_ok)
        let sla_rendimiento_error = parseInt(fromObjective.sla_rendimiento_error)
        let sla_disponibilidad_ok = parseInt(fromObjective.sla_disponibilidad_ok)
        let sla_disponibilidad_error = parseInt(fromObjective.sla_disponibilidad_error)
        let fecha_inicio = null
        let fecha_termino = null
        let token = sessionStorage.getItem('key')
        let user = sessionStorage.getItem('user')
        let finalTime = (moment().format('YYYY-MM-DD HH:mm'))
        let beginTime = (moment().subtract(1, "hours").format('YYYY-MM-DD HH:mm'))
        if (this.state.time === 'd') {
            beginTime = (moment().subtract(1, "days").format('YYYY-MM-DD HH:mm'))
        } else if (this.state.time === 'w') {
            beginTime = (moment().subtract(1, "weeks").format('YYYY-MM-DD HH:mm'))
        } else if (this.state.time === '3h') {
            beginTime = (moment().subtract(3, "hours").format('YYYY-MM-DD HH:mm'))
        } else if (this.state.time === '3d') {
            beginTime = (moment().subtract(3, "days").format('YYYY-MM-DD HH:mm'))
        }

        if (period === 'c') {

            fecha_inicio = statePeriod.startDate.toISOString().substring(0, 10) + " 00:00"
            fecha_termino = statePeriod.endDate.toISOString().substring(0, 10) + " 00:00"
            if(fecha_inicio===fecha_termino){
                fecha_termino=moment(fecha_inicio).add("1","days").format("Y-MM-DD HH:mm")
            }
            
            fetch(api_host+`/reporte/online/eventos/Reporte3Events/?user=${user}&key=${api_auth}&objetive=${objetivo_id}&datebegin=${fecha_inicio}&finaldate=${fecha_termino}&hash=3276bd408a114308ab00c6133fe29fb2&token=${token}`)
                .then(response => response.json())
                .then(myJson => {
                    if (myJson.status == 1 || myJson.status == 5) {
                        localStorage.setItem('isAuthenticated', false);
                    } else {
                        //Procesa la Data Recibida
                        try {
                            this.processData(myJson, sla_rendimiento_ok,
                                sla_rendimiento_error,
                                sla_disponibilidad_ok,
                                sla_disponibilidad_error,
                                period,
                                fecha_inicio,
                                fecha_termino)
                            if (this.state.lastEvent && this.state.lastEvent.length > 0) {
                                this.props.params.onFirstInfo(this.state.lastEvent)
                            }
                        } catch (error) {
                            this.setState({
                                dataError: true,
                                data: null,
                                isLoading: false
                            });
                        }
                    }
                });
        } else {
            //console.log(api_host+`/reporte/online/eventos/Reporte3Events/?user=${user}&key=${api_auth}&objetive=${objetivo_id}&datebegin=${beginTime}&finaldate=${finalTime}&hash=3276bd408a114308ab00c6133fe29fb2&token=${token}`)
            fetch(api_host+`/reporte/online/eventos/Reporte3Events/?user=${user}&key=${api_auth}&objetive=${objetivo_id}&datebegin=${beginTime}&finaldate=${finalTime}&hash=3276bd408a114308ab00c6133fe29fb2&token=${token}`)
                .then(response => response.json())
                .then(myJson => {
                    // Se define el state de acuerdo a la petición y respuesta de la promesa 
                    if (myJson.status == 1 || myJson.status == 5) {
                        localStorage.setItem('isAuthenticated', false);                        
                    } else {
                        //Procesa la Data Recibida
                        try {
                            this.processData(myJson, sla_rendimiento_ok,
                                sla_rendimiento_error,
                                sla_disponibilidad_ok,
                                sla_disponibilidad_error,
                                period,
                                fecha_inicio,
                                fecha_termino)
                            if (this.state.lastEvent && this.state.lastEvent.length > 0) {
                                this.props.params.onFirstInfo(this.state.lastEvent)
                            }
                        } catch (error) {
                            this.setState({
                                dataError: true,
                                data: null,
                                isLoading: false
                            });
                        }
                    }

                });

        }
    }

    // Helper para procesar la data de la petición a la API

    processData = (externalData,
        sla_rendimiento_ok,
        sla_rendimiento_error,
        sla_disponibilidad_ok,
        sla_disponibilidad_error,
        period,
        fecha_inicio,
        fecha_termino) => {
        const { t } = this.props;
        let lastEventDict = []
        let chartTitle = ""
        let chartSerieUp = []
        let chartSerieDown = []
        let chartSerieNoMon = []
        let chartCategory = []

        var steps=this.props.location.state.fromObjective.Pasos
        steps.map((step, forEachKey)=>{
            //console.log(step)
            chartCategory.push(step.nombre_paso)
            let contUpDuration = 0
            let contDownDuration = 0
            let contNoMonDuration = 0
            externalData.map((nodeData)=>{
                //console.log(nodeData.nombre_nodo)
                nodeData.data_nodo.map(dataEvents=>{
                    var estado=0
                    dataEvents.map(events=>{
                        var stateEvent=(events.pasos.filter(i=>i.id===step.id_paso)[0])
                        var contPattern=0
                        var contPatternDown=0
                        var contPatternNoMon=0
                        let duration=0
                        if((String(events.duracion)).split(" ").length===1){
                            duration = moment.duration(events.duracion).asSeconds()
                        }else{
                            var actual=((String(events.duracion).split(" ")))[2]
                            actual=moment.duration(actual).asSeconds()
                            var days=parseInt(((String(events.duracion).split(" ")))[0])
                            var durationDays=days*86400
                            duration=durationDays+actual
                        }
                        if(stateEvent.patrones){
                            stateEvent.patrones.map(patron=>{
                                if (at_codes_ok.map(i=>i.id).includes(parseInt(patron.estado))) {
                                    contPattern+=1
                                } else if (patron.estado === "sin monitoreo") {
                                    contPatternNoMon+=1
                                } else {
                                    contPatternDown+=1
                                }
                            })
                            if(contPattern>0){
                                estado=0
                            }else if(contPatternDown>0){
                                estado=3
                            }else if(contPatternNoMon>0 && contPattern===0&& contPatternDown===0){
                                estado=5
                            }
                        }else{
                            if( at_codes_ok.map(i=>i.id).includes(parseInt(stateEvent.estado))) {
                                estado = 0
                            } else if (stateEvent.estado === "sin monitoreo") {
                                estado = 5
                            } else {
                                estado = 3
                            }
                        }
                        if (estado === 0) {
                            contUpDuration = contUpDuration + duration
                        } else if (estado === 5) {
                            contNoMonDuration = contNoMonDuration + duration
                        } else {
                            contDownDuration = contDownDuration + duration
                        }
                    })
                })
            })
            contNoMonDuration=0
            let total=0
            total = contUpDuration + contNoMonDuration + contDownDuration
            contUpDuration = parseFloat((contUpDuration * 100 / total).toFixed(2))
            contDownDuration = parseFloat((contDownDuration * 100 / total).toFixed(2))
            contNoMonDuration = parseFloat((contNoMonDuration * 100 / total).toFixed(2))
            if (forEachKey == 0 /*&& key == 0*/) {
                lastEventDict['x'] = 'uptime'
                lastEventDict['y'] = contUpDuration
                lastEventDict['name'] = step.nombre_paso;
                if (period === 'h') {
                    lastEventDict['namePeriod'] = `${t('text.range')}: ${t('text.last-hour')}`
                } else if (period === 'd') {
                    lastEventDict['namePeriod'] = `${t('text.range')}: ${t('period.text.last-day')}`
                } else if (period === 'w') {
                    lastEventDict['namePeriod'] = `${t('text.range')}: ${t('period.text.last-week')}`
                } else if (period === 'c') {
                    lastEventDict['namePeriod'] = `${t('text.range')}: ${fecha_inicio} ${t('text.to2')} ${fecha_termino}`
                }
            }
            chartSerieUp.push(contUpDuration)
            chartSerieDown.push(contDownDuration)
            chartSerieNoMon.push(contNoMonDuration)
        })


        this.setState({
            chartOptions: {
                plotOptions: {
                    series: {
                        point: {
                            events: {
                                mouseOver: this.setHoverData.bind(this)
                            }
                        }
                    }
                },
                /*yAxis: {
                    plotLines: [{
                        value: sla_disponibilidad_ok,
                        color: '#54a51c',
                        width: 2,
                        zIndex: 3
                    }, {
                        value: sla_disponibilidad_error,
                        color: '#D22129',
                        width: 2,
                        zIndex: 3
                    }]
                },*/
                xAxis: {
                    categories: chartCategory
                },
                title: {
                    text: chartTitle
                },
                series: [
                    {
                        name: t('availability-node-detail.chart.series.uptime'), color: "#41B900", data: chartSerieUp
                    },
                    {
                        name: t('availability-node-detail.chart.series.downtime'), color: "#C2272D", data: chartSerieDown
                    },
                    {
                        name: t('availability-node-detail.chart.series.no-monitoring'), color: "#A9A9A9", data: chartSerieNoMon
                    },
                ]
            },
            dataError: false,
            isLoading: false,
            lastEvent: lastEventDict,
            time: period,
            chartOptionsBase: {
                ...this._chartOptionsBase(),
                xAxis: {
                    ...this._chartOptionsBase().xAxis,
                    categories: chartCategory
                },
                series: [
                    {
                        name: t('availability-node-detail.chart.series.uptime'), color: "#41B900", data: chartSerieUp
                    },
                    {
                        name: t('availability-node-detail.chart.series.downtime'), color: "#C2272D", data: chartSerieDown
                    },
                    {
                        name: t('availability-node-detail.chart.series.no-monitoring'), color: "#A9A9A9", data: chartSerieNoMon
                    },
                ]
            }
        });

    }
    render() {
        const { t } = this.props;
        const { dataError, chartOptions, isLoading ,chartOptionsBase} = this.state;
        const style = isLoading ? { display: 'none' } : {};
        const styleHidden = isLoading ? {} : { display: 'none' };
        if (!dataError) {
            sessionStorage.setItem("chartAvailabilityNodeDetail",JSON.stringify(chartOptionsBase))
            return (<FormattedChart chartOptions={chartOptions} style={style} styleHidden={styleHidden} />)
        }
        else if (dataError) {
            return (<p>{t('text.no-data')}</p>)
        }
        else return (<p>{t('availability-node-detail.error')}</p >)

    }
}

function FormattedChart(props) {
    const { t } = useTranslation()
    return (
        <div >
            <div style={props.styleHidden}>
            <PortletContent>
                <PerfectScrollbar>

                    <Typography
                      variant="h5"
                    >
                     <CircularProgress
                      variant="indeterminate"

                      size={24}
                      thickness={4}
                      
                    />
                    <br/>
                     {t('text.loading')}
                   </Typography>
                  </PerfectScrollbar>
            </PortletContent>
            </div>
            <div style={props.style}>
                <HighchartsReact
                    highcharts={Highcharts}
                    options={props.chartOptions} />
            </div>
        </div>
    )
}



export default compose(withRouter, withTranslation())(AvailabilityNodeDetail);